module.exports = __webpack_public_path__ + "img/symbol_11.2bd885a8.png";